import script from "./ApprovalHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApprovalHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ApprovalHeader.vue?vue&type=style&index=0&id=a7c60a96&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7c60a96"]])

export default __exports__